var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('transferItems',{attrs:{"StoreInfo":_vm.UserInfo,"BranchColor":"warning","headers":_vm.headers,"products":_vm.products}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }